"use client";

import { AuthGatewayProviders } from "@miadvg/auth-gateway/next-client";
import { ConfigProvider } from "@miadvg/config";
import { PostHogProvider } from "@miadvg/posthog";

import { ClientSessionHintSync } from "@/components/auth/client-session-hint-sync";
import { Toaster } from "@/components/ui/sonner";
import {
  createBookingClientGatewayConfig,
} from "@/lib/auth/client-config";
import {
  BOOKING_STAFF_APP_SLUG,
  BOOKING_STAFF_AUTH_CALLBACK_PATH,
  BOOKING_STAFF_SIGN_OUT_PATH,
} from "@/lib/auth/staff-shared";
import { setClientSessionHintCookie } from "@/lib/client-session-hint";

interface ProvidersProps {
  children: React.ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  const clientConfig = {
    ...createBookingClientGatewayConfig(),
    onSignedIn: () => {
      void setClientSessionHintCookie();
    },
  };

  return (
    <ConfigProvider required={["NEXT_PUBLIC_AUTH_GATEWAY_URL"]}>
      <PostHogProvider
        options={{
          api_host: "/ingest",
          ui_host: "https://us.i.posthog.com",
        }}
      >
        <AuthGatewayProviders
          staff={{
            appSlug: BOOKING_STAFF_APP_SLUG,
            callbackPath: BOOKING_STAFF_AUTH_CALLBACK_PATH,
            signOutPath: BOOKING_STAFF_SIGN_OUT_PATH,
          }}
          client={clientConfig}
        >
          <ClientSessionHintSync />
          {children}
          <Toaster />
        </AuthGatewayProviders>
      </PostHogProvider>
    </ConfigProvider>
  );
}
